/**
 * Plugin Notification
 * Doc: https://github.com/Maronato/vue-toastification#usage
 */

import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

export default defineNuxtPlugin(() => {
  const nuxtApp = useNuxtApp()
  const options = {
    // You can set your default options here
    timeout: 5000,
    // rtl: true,
    containerClassName: 'hts-toastification__container',
    toastClassName: 'toastification',
    bodyClassName: 'toastification-body',
    closeOnClick: false,
    showCloseButtonOnHover: true,
    closeButton: 'button'
  }

  nuxtApp.vueApp.use(Toast, options)
})
